import '../Styles/About.css';

export const About = () => {
    return (
        <div className="about-container">
            <h1 className="about-heading">About Us</h1>
            <p className="about-text">
                Your ultimate tool for tracking and managing your financial health? No, it's just a basic app made by me through my journey in the Develope for Nations bootcamp funded by the Australian embassy with the help of the Tunisian organization MentorNations. This about page is just for looks. My app is designed to help you effortlessly calculate and monitor your incomes and outcomes, giving you a clear and comprehensive view of your financial status. Whether you're budgeting for personal expenses or planning for future investments, our user-friendly interface and powerful features make it easy to stay on top of your finances. With real-time updates and detailed reports, you can make informed decisions and achieve your financial goals with confidence. Start managing your money smarter today with our Finance Management App!
            </p>
        </div>
    );
};
